import {CoreSettingsParameters, ISettings, SettingsParametersSchema} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot/configs/SlotSettings';

export type RegulationTypes = 'german' | 'MGA' | 'UK' | 'poland' | 'netherlands' | 'sa' | 'ontario' | 'spain' | 'colombia' | 'peru';

export interface GameClientWrapperSettingsParameters {
    offlineModeBalance?: number;
    offlineModeDefaultBetIndex?: number;
    offlineModeBetsMultiplier?: number;
    offlineModeBetsList?: number[];
    regulationType?: RegulationTypes;
    buyFeatureDisabled?: boolean;
}

export type GameClientWrapperSettings = ISettings<CoreSettingsParameters & SlotSettingsParameters & GameClientWrapperSettingsParameters>;

export const GAME_CLIENT_WRAPPER_SETTINGS_PARAMETERS_SCHEMA: SettingsParametersSchema<GameClientWrapperSettingsParameters> = {
    offlineModeBalance: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            alias: 'demo_balance',
            typePropertyInURL: 'number',
            parseValue: value => value * 100
        }
    },
    offlineModeBetsList: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            alias: 'demo_betsList',
            typePropertyInURL: 'array',
            parseValue: value => value.map(Number)
        }
    },
    offlineModeBetsMultiplier: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            alias: 'demo_betsMultiplier',
            typePropertyInURL: 'number'
        }
    },
    offlineModeDefaultBetIndex: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            alias: 'demo_defaultBetIndex',
            typePropertyInURL: 'number'
        }
    },
    regulationType: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            typePropertyInURL: 'string',
            alias: ['regulationType', 'RegulationType', 'regulationtype']
        }
    },
    buyFeatureDisabled: {
        readonly: true,
        defaultValue: false,
        urlParser: {
            typePropertyInURL: 'boolean'
        }
    }
};
